import type { ProviderKeyWithAll } from 'entities/provider'
import { Providers, TrendingSubjectProvider } from 'generated/graphql'

export const PROVIDER_BY_KEY: Record<ProviderKeyWithAll, Providers | TrendingSubjectProvider> = {
  all: TrendingSubjectProvider.All,
  yt: Providers.Yt,
  fb: Providers.Fb,
  tw: Providers.Tw,
  in: Providers.In,
  tt: Providers.Tt,
}
